import { combineReducers } from "redux";

import Selected from "./Selected";
import Common from "./Common";
import Direction from "./Direction";
import Type from "./Type";
import Specialization from "./Specialization";

export default combineReducers({
  Selected,
  Common,
  Direction,
  Type,
  Specialization,
});
